import { defineComponent as _defineComponent } from 'vue'
import LinkedinIcon from '@/assets/svg/linkedin.vue.svg';
import type { IPostContentDataLinkedin } from '@/types/community';

type WarRoomPostContentLinkedinProps = {
  content: IPostContentDataLinkedin;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomPostContentLinkedin',
  props: {
    content: null
  },
  setup(__props: any) {



const IMAGE_SIZE = 64;

return { __sfc: true,IMAGE_SIZE, LinkedinIcon }
}

})